import React from 'react';
import ReactDOM from 'react-dom/client';
import { bindActionCreators } from 'redux';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import './global';
import * as serviceWorker from './serviceWorker';
import initStore from './store';
import ErrorBoundary from './shared/error/error-boundary';
import App from './containers/App';
import { clearAuthentication, accessDenied } from './reducers/authentication';
import setupAxiosInterceptors from './config/axios-interceptor';
import PrimeReact, { locale, addLocale } from 'primereact/api';

import 'primereact/resources/themes/saga-green/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.min.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react18-json-view/src/style.css';
import './index.scss';

import './fonts/Inter/Inter-Regular-slnt=0.ttf';
import './fonts/Inter/Inter-Bold-slnt=0.ttf';

// declare const navigator;
PrimeReact.ripple = true;

addLocale('uk', {
    firstDayOfWeek: 1,
    dayNames: ['Неділя', 'Понеділок', 'Вівторок', 'Середа', 'Четвер', "П'ятниця", 'Субота'],
    dayNamesShort: ['Нед', 'Пон', 'Вів', 'Сер', 'Чет', "П'ят", 'Суб'],
    dayNamesMin: ['НД', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ'],
    monthNames: [
        'Січень',
        'Лютий',
        'Березень',
        'Квітень',
        'Травень',
        'Червень',
        'Липень',
        'Серпень',
        'Вересень',
        'Жовтень',
        'Листопад',
        'Грудень',
    ],
    monthNamesShort: ['Січ', 'Лют', 'Бер', 'Кві', 'Тра', 'Чер', 'Лип', 'Сер', 'Вер', 'Жов', 'Лис', 'Гру'],
    today: 'Сьогодні',
    clear: 'Скасувати',
    apply: 'Застосувати',
});
locale('uk');

const store = initStore();
if (process.env.NODE_ENV !== 'production') {
    store.subscribe(() => console.log('### React store changed ###', store.getState()));
}
const actions = bindActionCreators({ clearAuthentication, accessDenied }, store.dispatch);
setupAxiosInterceptors(
    () => actions.clearAuthentication('login.error.unauthorized'),
    () => actions.accessDenied('error.http.403'),
);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const render = (Component) => {
    root.render(
        <ErrorBoundary>
            <Provider store={store}>
                <ToastContainer />

                <Component />
            </Provider>
        </ErrorBoundary>,
    );
};

render(App);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
